module.exports = __webpack_public_path__ + "assets/a4db77963b2296c48db1dddc1807a625.png";